<template>
  <div class="bridge-signing-view container fluid">
    <v-card>
      <Paybacks />
    </v-card>
  </div>
</template>

<script>
import { Paybacks } from '@/components/payoutsAndTaxes';

export default {
  name: 'PaybacksView',
  components: {
    Paybacks,
  },
  data() {
    return {};
  },
  mounted() {
    this.refresh();
  },
  methods: {
    refresh() {
      this.$store.dispatch('fetchPatPaybackTypes');
      this.$store.dispatch('fetchPatPaybacksAll');
    },
  },
};
</script>

<style lang="scss">
.bridge-signing-view {
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/views/payoutsAndTaxes/paybacks/PaybacksView.vue